import { GLE2O } from "../../data/OSSD/Grade10/GLE2O";
import GradeCourseTemplate from "../../pageTemplate/GradeCourseTemplate";


export default function GLE2OPage() {
    return (
        <div>
            <GradeCourseTemplate data={GLE2O} />
        </div>
    )
}